exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body.shepherd-active .first-form-steps .form-url{position:relative;box-shadow:0 0 0 99999px rgba(0,0,0,.5);z-index:9999;pointer-events:auto;transition:all .3s ease}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./components/dashboard/forms/tour/first_form/first_form.css
// module id = 758
// module chunks = 0